import React from 'react';
import { FlexboxGrid, Row, Text } from 'rsuite';
import '../../css/tables.css';

export interface SummaryRow {
  label: string;
  value: string;
  bold?: boolean;
}

interface TableComponentProps {
  data: SummaryRow[];
  title?: string;
}

export const TableComponent: React.FC<TableComponentProps> = ({
  data,
  title,
}) => {
  return (
    <FlexboxGrid>
      <FlexboxGrid.Item
        colspan={24}
        as={Row}
      >
        <Text
          as="h4"
          style={{ marginBottom: 8 }}
        >
          {title}
        </Text>
      </FlexboxGrid.Item>
      {data.map((rowData, index) => {
        return (
          <FlexboxGrid.Item
            key={`index-${rowData.label}`}
            as={Row}
            colspan={24}
            style={{ fontWeight: rowData.bold ? 700 : 400, fontSize: '14px' }}
          >
            <FlexboxGrid
              style={{
                background: index % 2 === 0 ? '#F5F5F5' : '#fff',
                padding: '6px 4px',
              }}
            >
              <FlexboxGrid.Item colspan={20}>
                <Text>{rowData.label}</Text>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item
                colspan={4}
                style={{
                  textAlign: 'right',
                }}
              >
                <Text>{rowData.value}</Text>
              </FlexboxGrid.Item>
            </FlexboxGrid>
          </FlexboxGrid.Item>
        );
      })}
    </FlexboxGrid>
  );
};
